var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5834 12.9998C29.5834 10.1181 28.3267 7.51812 26.3334 5.74146V20.2365C28.3267 18.4815 29.5834 15.8815 29.5834 12.9998Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66671 6.5C2.28337 6.5 0.333374 8.45 0.333374 10.8333V15.1667C0.333374 17.55 2.28337 19.5 4.66671 19.5H6.83337V28.1667H11.1667V19.5H13.3334L24.1667 26V0L13.3334 6.5H4.66671ZM15.565 10.205L19.8334 7.64833V18.3517L15.565 15.795L14.525 15.1667H4.66671V10.8333H14.525L15.565 10.205Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.07a129b159dc909a4089e1dccea13525.svg";
export { ForwardRef as ReactComponent };